export default __webpack_public_path__ + "609f47e1681a8a860f0dc55799f2a626.png";